import { AppAlert } from '@components/antd';
import { useSupportChat } from '@shared/hooks/use-support-chat';
import { Trans } from 'react-i18next';

export const AccountSuspendedBanner = () => {
  const { openSupportChat } = useSupportChat();
  return (
    <AppAlert
      showIcon
      type="error"
      message={
        <p>
          <Trans
            i18nKey="your_calilio_account_has_been_suspended_please_contact_customer_support"
            components={[
              <span key="support-link" className="cursor-pointer text-amber-700" onClick={openSupportChat}></span>,
            ]}
          />
        </p>
      }
    />
  );
};
